/**
 * The one pricing badge, for both card grids.
 *
 * There were two. The directory rendered a single outlined pill reading
 * "Free & paid"; the Resource Center rendered one green pill and one blue
 * pill side by side, on square corners. Same fact, two answers, and the
 * Resource Center's version was the one the directory had already moved away
 * from — a tool with both tiers showed two pills, which reads as two
 * competing facts rather than the single fact that there is a free tier and a
 * paid one. Nearly every entry has both.
 *
 * Colour was the other half of it. Emerald and blue are not on this site's
 * palette anywhere else, and they made the badge the loudest thing on a card
 * whose actual job is the tool's name. Outlined and muted lets it sit where it
 * belongs: available when you look for it, silent when you are not.
 */

import type { PricingType } from "@/lib/resourcesData";

export default function PricingBadge({ types }: { types: PricingType[] }) {
  if (types.length === 0) return null;

  return (
    <span className="text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap bg-transparent text-muted-foreground border border-border">
      {types.length > 1 ? "Free & paid" : types[0]}
    </span>
  );
}
